// Scripts for navigation related functionality

import {gsap} from "gsap";

// Prevent anchor tags from showing in URL. Using CSS smooth scrolling rather than a JS plugin.
let anchorLinks = document.querySelectorAll("a[href^=\'#\'] ");

anchorLinks.forEach(anchor => {
  anchor.addEventListener("click", function (event) {
    setTimeout(() => {
      history.replaceState(null, null, ' ');
    }, 5);
  });
});

const body = document.querySelector("body");
const header = document.querySelector("#site-header");
const menuIcon = document.querySelector("#menu-icon");

const headerInfo = document.querySelector("#header-info");
const registerButton = document.querySelector(".register-button");
const logo = document.querySelector(".logo");
const nav = document.querySelector("nav");
const overlay = document.querySelector(".overlay");
const pageContent = [document.querySelector("main"), document.querySelector("footer")];
const footer = document.querySelector("#site-footer");


window.addEventListener("click", (event) => {
  if (header) {
    if (!header.contains(event.target)) {
      if (nav.classList.contains('visible')) {
        toggleNav();
      }
    }
  }
})
if (menuIcon) {
  menuIcon.addEventListener("click", toggleNav);
}

function toggleNav() {
  nav.classList.toggle('visible');
  if (nav.classList.contains("visible")) {
    gsap.to(nav, {
      y: 0,
      duration: 0.8,
      ease: "power1.inOut"
    })
  } else {
    gsap.to(nav, {
      y: "-98.5%",
      duration: 0.8,
      ease: "power1.inOut"
    })
  }

  const menuIconLines = menuIcon.querySelectorAll(".menu-icon-line");

  if (menuIconLines.length > 0) {
    menuIconLines[0].classList.toggle('rotate1');
    menuIconLines[1].classList.toggle('fade-out');
    menuIconLines[2].classList.toggle('rotate2');
  }
  if (nav.classList.contains('visible')) {
    header.classList.add('fixed');
    // footer.classList.add('shift-footer-back');

  } else {
    header.classList.remove('fixed');
    setTimeout(() => {
      // footer.classList.remove('shift-footer-back');
    }, 750)
  }

  headerInfo.classList.toggle('white-text');
  registerButton.classList.toggle("visible");
  logo.classList.toggle("visible");
  logo.classList.add("with-transition");
  pageContent.forEach(e => {
    e.classList.toggle('blur');
    if (e.classList.contains('move-forward')) {
      setTimeout(() => {
        e.classList.toggle('move-forward');
      }, 500);
    } else {
      e.classList.toggle('move-forward');
    }

  })
}

const upArrows = document.querySelectorAll('.up-arrow')

upArrows.forEach(arrow => {
  arrow.addEventListener("click", () => {
    window.scrollTo(0, 0);
  })
})


// ------------------------------------------------------------

const creditLink = document.querySelector(".credit-link");

if (creditLink) {
  creditLink.addEventListener("mouseover", () => {
    creditLink.textContent = 'DD LONDON';
  });
  creditLink.addEventListener("mouseout", () => {
    creditLink.textContent = 'Credit';
  })
}

export {toggleNav}


// ------------------------------------------------------------


